module.exports = __webpack_public_path__ + "img/icon-understand-blue.b95e3eea.png";